<template>
    <div id="pageTable" class="my-loads">
        <template v-if="!clientUserAgent">
            <v-container grid-list-xl fluid paddingZero>
                <v-layout row wrap style="margin-bottom:60px;">                    

                    <!-- mini statistic start -->
                    <v-flex lg12 pb-0>
                        <v-card>
                            <v-toolbar card color="white">
                                <v-toolbar-title>
                                    <h3>My Loads</h3>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <router-link class="link-btn" v-if="permissionName=='all'" :to="{name: 'AddLoad'}">
                                    <v-icon color="black">add</v-icon>
                                </router-link>
                            </v-toolbar>
                            <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                            <v-divider></v-divider>
                            <v-tabs v-model="selectedTab" slider-color="orange" @change="onTabChange">
                                <v-flex xs12>
                                    <v-tab ripple> My Loads </v-tab>
                                    <v-tab ripple> Load Templates </v-tab>
                                    <v-tab ripple > Recurring Loads </v-tab>
                                </v-flex>
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <v-text-field solo @input="onSearchChange" label="Search" append-outer-icon="search" v-model="loadsMeta.search" class="customTxt">
                                            </v-text-field>
                                        </v-card-text>
                                        <v-toolbar color="grey darken-1" dark>
                                            <v-flex xs12 md3>
                                                PAGE {{loadsMeta.pagination.currPage}} of {{loadsMeta.pagination.maxPages}} ({{loadsMeta.totalRecords}} {{loadsMeta.totalRecords > 1 ? 'LOADS': 'LOADS'}})
                                            </v-flex>
                                            <v-flex xs12 md6 class="text-xs-center">
                                                <v-pagination v-if="loadsMeta.loads.length" v-model="loadsMeta.pagination.currPage" @input="onPageChange" :length="loadsMeta.pagination.maxPages" :total-visible="7"></v-pagination>
                                            </v-flex>
                                            <v-flex xs12 md3 class="text-xs-right">
                                                <v-layout align-center justify-end row fill-height class="text-xs-right">
                                                    <v-flex xs8 class="text-xs-right"> SHOW</v-flex>
                                                    <v-flex xs4 class="text-xs-right">
                                                        <v-select v-model="loadsMeta.pagination.perPage" @input="setPerPage" :items="[{'text': '10', value: 10}, {'text': '25', 'value':25}, {'text': '50', 'value':50},{'text': '100', 'value':100}]"></v-select>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-toolbar>
                                        <div class="v-table__overflow">
                                            <table class="custom_table" cellpadding="0" width="100%">
                                                <thead>
                                                    <tr>
                                                        <th @click="switchSort('updated_at', 'num')" class="sortable" >
                                                            <v-icon color="orange">{{getSortArrow('updated_at')}}</v-icon>Age
                                                        </th>
                                                        <th @click="switchSort('origin_city')" class="sortable" width="150px">
                                                            <v-icon color="orange">{{getSortArrow('origin_city')}}</v-icon>ORIGIN
                                                        </th>
                                                        <th @click="switchSort('dest_city')" class="sortable" width="150px">
                                                            <v-icon color="orange">{{getSortArrow('dest_city')}}</v-icon>DESTINATION
                                                        </th>                                                
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                <tr>
                                                                    <td @click="switchSort('pickup_date')" class="sortable">
                                                                        <v-icon color="orange">{{getSortArrow('pickup_date')}}</v-icon>PICKUP
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>RATE</td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr>
                                                                    <td class="sortable" colspan="2">
                                                                        Equipment
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td @click="switchSort('load_size')" class="sortable" width="45%">
                                                                        <v-icon color="orange">{{getSortArrow('load_size')}}</v-icon>Size
                                                                    </td>
                                                                    <td @click="switchSort('length', 'num')" class="sortable" width="55%">
                                                                        <v-icon color="orange">{{getSortArrow('length')}}</v-icon>Length
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr>
                                                                    <td @click="switchSort('distance', 'num')" class="sortable">
                                                                        <v-icon color="orange">{{getSortArrow('distance')}}</v-icon>Distance
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td @click="switchSort('weight', 'num')" class="sortable">
                                                                        <v-icon color="orange">{{getSortArrow('weight')}}</v-icon>Weight
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr>
                                                                    <td @click="switchSort('num_stops', 'num')" class="sortable">
                                                                        <v-icon color="orange">{{getSortArrow('num_stops')}}</v-icon>No of Stops
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td @click="switchSort('quantity', 'num')" class="sortable">
                                                                        <v-icon color="orange">{{getSortArrow('quantity')}}</v-icon>Quantity
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr rowspan="2">
                                                                    <td @click="switchSort('contact_phone', 'num')" class="sortable" width="61%">
                                                                        <v-icon color="orange">{{getSortArrow('contact_phone')}}</v-icon>Phone
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px" colspan="2">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr rowspan="2">
                                                                    <td>Actions</td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="loadsMeta.loads.length">
                                                    <template v-for="(load, index) in loadsMeta.pageLoads">
                                                        <tr v-bind:key="index" class="custom_table_tr" v-on:click="loadsMeta.selectedRow=loadsMeta.selectedRow && loadsMeta.selectedRow.uuid===load.uuid ? {} : load">
                                                            <td align="center" class="td-pos-rel">
                                                                <template v-if="load.frequency !=''"><v-icon class="icon-pos-abs" color="green">fas fa-sync-alt</v-icon><br></template>
                                                                <v-chip label color="orange" class="sm-case" text-color="white">{{load.age_display}} </v-chip>
                                                            </td>
                                                            <td colspan=2>
                                                                <table width="100%" border="0" cellpadding="0" class="subtableNO">
                                                                    <tr>
                                                                        <td width="45%" class="bold origin_city">{{utils.displayCityStateAny(load.origin_city, load.origin_state,load.origin_short_name)}}
                                                                        </td>
                                                                        <td width="10%" align="center">
                                                                            <v-icon color="orange">arrow_forward</v-icon>
                                                                        </td>
                                                                        <td width="45%" class="bold dest_city">{{utils.displayCityStateAny(load.dest_city, load.dest_state,load.dest_short_name)}}</td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr>
                                                                        <td align="center">{{load.pickup_date | moment("utc","MM/DD")}}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="center" class="rate" v-if="load.rate">{{load.rate}}</td>
                                                                        <td align="center" v-if="!load.rate" v-html="blankStr"></td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr>
                                                                        <td colspan="2" align="center">
                                                                            {{load.equipment_name}}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="50%" align="center">{{load.load_size}}</td>
                                                                        <td width="50%" class="sm-case length" align="center">{{load.length}} ft</td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr>
                                                                        <td align="center">{{load.distance}} <span v-if="load.distance != 'Not provided'">Miles</span></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="center">{{load.weight}} lbs</td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr>
                                                                        <td align="center">{{load.num_stops}}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="center">{{load.quantity}}</td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr rowspan="2">
                                                                        <template v-if="load.contact_phone.includes(',')">
                                                                            <td align="center"> 
                                                                                <a v-for="(valPh, iPh) in load.contact_phone.split(',')" class="link-text" target="_blank"  :href="'tel:' + valPh" >{{valPh | phone}} </br></a>
                                                                            </td>
                                                                        </template>
                                                                        <template v-else>
                                                                            <td align="center"> <a class="link-text" target="_blank"  :href="'tel:' + load.contact_phone" >{{load.contact_phone | phone}}</a></td>
                                                                        </template>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtatruck.dest_cityble action">
                                                                    <tr rowspan="2">
                                                                        <td align="center" class="non-border">
                                                                            <template v-if="load.load_view_count > 0">
                                                                                <v-btn v-on:click.stop="loadViewByClick(load)" depressed outline icon fab dark small >
                                                                                    <v-icon color="orange">fa-users</v-icon>
                                                                                </v-btn>
                                                                            </template>
                                                                            <template v-else>
                                                                                <v-tooltip top>
                                                                                    <v-btn slot="activator" v-on:click.stop="" depressed outline icon fab dark small >
                                                                                        <v-icon color="#8a8a8a">fa-users</v-icon>
                                                                                    </v-btn>
                                                                                    <span>No one has viewed yet</span>
                                                                                </v-tooltip>
                                                                            </template>
                                                                        </td>                                                                                                                                               
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtatruck.dest_cityble action">
                                                                    <tr rowspan="2">
                                                                        <td align="center" class="non-border">
                                                                            <v-btn depressed outline icon fab dark color="orange" small>
                                                                                <v-icon color="orange">fa-eye</v-icon>
                                                                            </v-btn>
                                                                            <template v-if="(load.is_parent == 0 && load.is_recurring == 0) || (load.is_parent == 1 && load.is_recurring == 1)">
                                                                                <v-btn v-if="permissionName=='all'" :to="{name:'EditLoad', params:{id:load.uuid}}" depressed outline icon fab dark color="orange" small>
                                                                                    <v-icon>fa-edit</v-icon>
                                                                                </v-btn>
                                                                            </template>
                                                                            <v-btn class="custom_table_trash" v-if="permissionName=='all'" depressed outline icon fab dark color="red" small v-on:click.stop="DeleteLoadClick(load, 'load')">
                                                                                <v-icon>fa-trash</v-icon>
                                                                            </v-btn>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="loadsMeta.selectedRow.uuid && loadsMeta.selectedRow.uuid===load.uuid" v-bind:key="`${index+'detail'}`">
                                                            <!--<td colspan="9" align="center" v-html="getRowDetail(load, renderMap, 'load')">-->
                                                            <td colspan="10" align="center">
                                                                <LoadInfo fromComponent="loadList" :DeleteLoadClick="DeleteLoadClick" :clientUserAgent="clientUserAgent" :loadViewByClick="loadViewByClick" :permissionName="permissionName" :load="loadsMeta.selectedRow" :aggregatorsKeyVal="aggregatorsKeyVal" :renderMap="renderMap" type="load"> </LoadInfo>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td colspan="9" align="center" valign="middle" class="noRecord">{{noRecordFoundStr}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <v-toolbar color="grey darken-1" dark>
                                            <v-flex xs12 md3>
                                                PAGE {{loadsMeta.pagination.currPage}} of {{loadsMeta.pagination.maxPages}} ({{loadsMeta.totalRecords}} {{loadsMeta.totalRecords > 1 ? 'LOADS': 'LOADS'}})
                                            </v-flex>
                                            <v-flex xs12 md6 class="text-xs-center">
                                                <v-pagination v-if="loadsMeta.loads.length" v-model="loadsMeta.pagination.currPage" @input="onPageChange" :length="loadsMeta.pagination.maxPages" :total-visible="7"></v-pagination>
                                            </v-flex>
                                            <v-flex xs12 md3 class="text-xs-right">
                                                <v-layout align-center justify-end row fill-height class="text-xs-right">
                                                    <v-flex xs8 class="text-xs-right"> SHOW</v-flex>
                                                    <v-flex xs4 class="text-xs-right">
                                                        <v-select v-model="loadsMeta.pagination.perPage" @input="setPerPage" :items="[{'text': '10', value: 10}, {'text': '25', 'value':25}, {'text': '50', 'value':50},{'text': '100', 'value':100}]"></v-select>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-toolbar>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <v-text-field solo @input="onSearchChange" label="Search" append-outer-icon="search" v-model="templMeta.search" class="customTxt">
                                            </v-text-field>
                                        </v-card-text>
                                        <v-toolbar color="grey darken-1" dark>
                                            <v-flex xs12 md3>
                                                PAGE {{templMeta.pagination.currPage}} of {{templMeta.pagination.maxPages}} ({{templMeta.templates.length}} {{templMeta.templates.length > 1 ? 'TEMPLATES': 'TEMPLATES'}})
                                            </v-flex>
                                            <v-flex xs12 md6 class="text-xs-center">
                                                <v-pagination v-if="templMeta.templates.length" v-model="templMeta.pagination.currPage" @input="onPageChange" :length="templMeta.pagination.maxPages" :total-visible="7"></v-pagination>
                                            </v-flex>
                                            <v-flex xs12 md3 class="text-xs-right">
                                                <v-layout align-center justify-end row fill-height class="text-xs-right">
                                                    <v-flex xs8 class="text-xs-right"> SHOW</v-flex>
                                                    <v-flex xs4 class="text-xs-right">
                                                        <v-select v-model="templMeta.pagination.perPage" @input="setPerPage" :items="[{'text': '10', value: 10}, {'text': '25', 'value':25}, {'text': '50', 'value':50},{'text': '100', 'value':100}]"></v-select>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-toolbar>
                                        <div class="v-table__overflow">
                                            <table width="100%" class="custom_table" cellpadding="0">
                                                <thead>
                                                    <tr>
                                                        <th width="150px" @click="switchSort('template_name')" class="sortable">
                                                            <v-icon color="orange">{{getSortArrow('template_name')}}</v-icon>TEMPLATE NAME
                                                        </th>
                                                        <th @click="switchSort('origin')" class="sortable" width="150px">
                                                            <v-icon color="orange">{{getSortArrow('origin')}}</v-icon>ORIGIN
                                                        </th>
                                                        <th @click="switchSort('dest')" class="sortable" width="150px">
                                                            <v-icon color="orange">{{getSortArrow('dest')}}</v-icon>DESTINATION
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                <tr rowspan="2">
                                                                    <td>RATE</td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr>
                                                                    <td class="sortable" colspan="2">
                                                                        Equipment
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td @click="switchSort('load_size')" class="sortable" width="45%">
                                                                        <v-icon color="orange">{{getSortArrow('load_size')}}</v-icon>Size
                                                                    </td>
                                                                    <td @click="switchSort('length', 'num')" class="sortable" width="55%">
                                                                        <v-icon color="orange">{{getSortArrow('length')}}</v-icon>Length
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr>
                                                                    <td @click="switchSort('distance', 'num')" class="sortable">
                                                                        <v-icon color="orange">{{getSortArrow('distance')}}</v-icon>Distance
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td @click="switchSort('weight', 'num')" class="sortable">
                                                                        <v-icon color="orange">{{getSortArrow('weight')}}</v-icon>Weight
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr rowspan="2">
                                                                    <td @click="switchSort('contact_phone', 'num')" class="sortable" width="61%">
                                                                        <v-icon color="orange">{{getSortArrow('contact_phone')}}</v-icon>Phone
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr rowspan="2">
                                                                    <td>Actions</td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="templMeta.templates.length">
                                                    <template v-for="(load, index) in templMeta.pageTemplates">
                                                        <tr v-bind:key="index" class="custom_table_tr" v-on:click="templMeta.selectedRow=templMeta.selectedRow && templMeta.selectedRow.uuid===load.uuid ? {} : load">
                                                            <td align="center" class="pr-2 pl-2">
                                                                {{load.template_name}}
                                                            </td>
                                                            <td colspan="2">
                                                                <table width="100%" border="0" cellpadding="0" class="subtableNO">
                                                                    <tr>
                                                                        <td width="45%" class="bold origin_city">{{utils.displayCityStateAny(load.origin_city, load.origin_state,load.origin_short_name)}}</td>
                                                                        <td width="10%" align="center">
                                                                            <v-icon color="orange">arrow_forward</v-icon>
                                                                        </td>
                                                                        <td width="45%" class="bold dest_city">{{utils.displayCityStateAny(load.dest_city, load.dest_state,load.dest_short_name)}}</td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr>
                                                                        <td align="center" class="rate" v-if="load.rate">{{load.rate}}</td>
                                                                        <td align="center" v-if="!load.rate" v-html="blankStr"></td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr>
                                                                        <td colspan="2" align="center">{{load.equipment_name}}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="50%" align="center">{{load.load_size}}</td>
                                                                        <td width="50%" class="sm-case length" align="center">{{load.length}} ft</td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr>
                                                                        <td align="center">{{load.distance}} <span v-if="load.distance != 'Not provided'">Miles</span></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="center">{{load.weight}} lbs</td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    
                                                                    <tr rowspan="2">
                                                                        <template v-if="load.contact_phone.includes(',')">
                                                                            <td align="center"> 
                                                                                <a v-for="(valPh, iPh) in load.contact_phone.split(',')" class="link-text" target="_blank"  :href="'tel:' + valPh" >{{valPh | phone}} </br></a>
                                                                            </td>
                                                                        </template>
                                                                        <template v-else>
                                                                            <td align="center"> <a class="link-text" target="_blank"  :href="'tel:' + load.contact_phone" >{{load.contact_phone | phone}}</a></td>
                                                                        </template>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable action">
                                                                    <tr rowspan="2">
                                                                        <td align="center">
                                                                            <v-btn depressed outline icon fab dark color="orange" small>
                                                                                <v-icon color="orange">fa-eye</v-icon>
                                                                            </v-btn>
                                                                            <v-btn  class="custom_table_trash" v-if="permissionName=='all'" depressed outline icon fab dark color="red" small v-on:click.stop="DeleteLoadClick(load, 'template')">
                                                                                <v-icon>fa-trash</v-icon>
                                                                            </v-btn>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="templMeta.selectedRow.uuid && templMeta.selectedRow.uuid===load.uuid" v-bind:key="`${index+'detail'}`">
                                                            <!--<td colspan="8" v-html="getRowDetail(load, renderMap, 'template')">-->
                                                            <td colspan="8">
                                                                <LoadInfo fromComponent="loadList" :DeleteLoadClick="DeleteLoadClick" :clientUserAgent="clientUserAgent" :loadViewByClick="loadViewByClick" :permissionName="permissionName" :load="templMeta.selectedRow" :aggregatorsKeyVal="aggregatorsKeyVal" :renderMap="renderMap" type="template"> </LoadInfo>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td colspan="8" align="center" class="noRecord">{{noRecordFoundStr}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <v-toolbar color="grey darken-1" dark>
                                            <v-flex xs12 md3>
                                                PAGE {{templMeta.pagination.currPage}} of {{templMeta.pagination.maxPages}} ({{templMeta.templates.length}} {{templMeta.templates.length > 1 ? 'TEMPLATES': 'TEMPLATES'}})
                                            </v-flex>
                                            <v-flex xs12 md6 class="text-xs-center">
                                                <v-pagination v-if="templMeta.templates.length" v-model="templMeta.pagination.currPage" @input="onPageChange" :length="templMeta.pagination.maxPages" :total-visible="7"></v-pagination>
                                            </v-flex>
                                            <v-flex xs12 md3 class="text-xs-right">
                                                <v-layout align-center justify-end row fill-height class="text-xs-right">
                                                    <v-flex xs8 class="text-xs-right"> SHOW</v-flex>
                                                    <v-flex xs4 class="text-xs-right">
                                                        <v-select v-model="templMeta.pagination.perPage" @input="setPerPage" :items="[{'text': '10', value: 10}, {'text': '25', 'value':25}, {'text': '50', 'value':50},{'text': '100', 'value':100}]"></v-select>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-toolbar>
                                    </v-card>
                                </v-tab-item>

                                <!-- Recurring Loads list start -->
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <v-text-field solo @input="onSearchChange" label="Search" append-outer-icon="search" v-model="loadsRecurMeta.search" class="customTxt">
                                            </v-text-field>
                                        </v-card-text>
                                        <v-toolbar color="grey darken-1" dark>
                                            <v-flex xs12 md3>
                                                PAGE {{loadsRecurMeta.pagination.currPage}} of {{loadsRecurMeta.pagination.maxPages}} ({{loadsRecurMeta.totalRecords}} {{loadsRecurMeta.totalRecords > 1 ? 'LOADS': 'LOADS'}})
                                            </v-flex>
                                            <v-flex xs12 md6 class="text-xs-center">
                                                <v-pagination v-if="loadsRecurMeta.loads.length" v-model="loadsRecurMeta.pagination.currPage" @input="onPageChange" :length="loadsRecurMeta.pagination.maxPages" :total-visible="7"></v-pagination>
                                            </v-flex>
                                            <v-flex xs12 md3 class="text-xs-right">
                                                <v-layout align-center justify-end row fill-height class="text-xs-right">
                                                    <v-flex xs8 class="text-xs-right"> SHOW</v-flex>
                                                    <v-flex xs4 class="text-xs-right">
                                                        <v-select v-model="loadsRecurMeta.pagination.perPage" @input="setPerPage" :items="[{'text': '10', value: 10}, {'text': '25', 'value':25}, {'text': '50', 'value':50},{'text': '100', 'value':100}]"></v-select>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-toolbar>
                                        <div class="v-table__overflow">
                                            <table class="custom_table" cellpadding="0" width="100%">
                                                <thead>
                                                    <tr>
                                                        <th @click="switchSort('updated_at', 'num')" class="sortable" width="50px">
                                                            <v-icon color="orange">{{getSortArrow('updated_at')}}</v-icon>Age
                                                        </th>
                                                        <th @click="switchSort('origin_city')" class="sortable" width="150px">
                                                            <v-icon color="orange">{{getSortArrow('origin_city')}}</v-icon>ORIGIN
                                                        </th>
                                                        <th @click="switchSort('dest_city')" class="sortable" width="150px">
                                                            <v-icon color="orange">{{getSortArrow('dest_city')}}</v-icon>DESTINATION
                                                        </th>                                                
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                <tr>
                                                                    <td @click="switchSort('pickup_date')" class="sortable">
                                                                        <v-icon color="orange">{{getSortArrow('pickup_date')}}</v-icon>PICKUP
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>RATE</td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr>
                                                                    <td class="sortable" colspan="2">
                                                                        Equipment
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td @click="switchSort('load_size')" class="sortable" width="45%">
                                                                        <v-icon color="orange">{{getSortArrow('load_size')}}</v-icon>Size
                                                                    </td>
                                                                    <td @click="switchSort('length', 'num')" class="sortable" width="55%">
                                                                        <v-icon color="orange">{{getSortArrow('length')}}</v-icon>Length
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr>
                                                                    <td @click="switchSort('distance', 'num')" class="sortable">
                                                                        <v-icon color="orange">{{getSortArrow('distance')}}</v-icon>Distance
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td @click="switchSort('weight', 'num')" class="sortable">
                                                                        <v-icon color="orange">{{getSortArrow('weight')}}</v-icon>Weight
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr>
                                                                    <td @click="switchSort('num_stops', 'num')" class="sortable">
                                                                        <v-icon color="orange">{{getSortArrow('num_stops')}}</v-icon>No of Stops
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td @click="switchSort('quantity', 'num')" class="sortable">
                                                                        <v-icon color="orange">{{getSortArrow('quantity')}}</v-icon>Quantity
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr rowspan="2">
                                                                    <td @click="switchSort('contact_phone', 'num')" class="sortable" width="61%">
                                                                        <v-icon color="orange">{{getSortArrow('contact_phone')}}</v-icon>Phone
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                        <th width="150px">
                                                            <table width="100%" border="0" cellpadding="5" class="subtable">
                                                                <tr rowspan="2">
                                                                    <td>Actions</td>
                                                                </tr>
                                                            </table>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="loadsRecurMeta.loads.length">
                                                    <template v-for="(load, index) in loadsRecurMeta.pageLoads">
                                                        <tr v-bind:key="index" class="custom_table_tr" v-on:click="loadsRecurMeta.selectedRow=loadsRecurMeta.selectedRow && loadsRecurMeta.selectedRow.uuid===load.uuid ? {} : load">
                                                            <td align="center">
                                                                <v-chip label color="orange" class="sm-case" text-color="white">{{load.age_display}} </v-chip>
                                                            </td>
                                                            <td colspan=2>
                                                                <table width="100%" border="0" cellpadding="0" class="subtableNO">
                                                                    <tr>
                                                                        <td width="45%" class="bold origin_city">{{utils.displayCityStateAny(load.origin_city, load.origin_state,load.origin_short_name)}}
                                                                        </td>
                                                                        <td width="10%" align="center">
                                                                            <v-icon color="orange">arrow_forward</v-icon>
                                                                        </td>
                                                                        <td width="45%" class="bold dest_city">{{utils.displayCityStateAny(load.dest_city, load.dest_state,load.dest_short_name)}}</td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr>
                                                                        <td align="center">{{load.pickup_date | moment("utc","MM/DD")}}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="center" class="rate" v-if="load.rate">{{load.rate}}</td>
                                                                        <td align="center" v-if="!load.rate" v-html="blankStr"></td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr>
                                                                        <td colspan="2" align="center">
                                                                            {{load.equipment_name}}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="50%" align="center">{{load.load_size}}</td>
                                                                        <td width="50%" class="sm-case length" align="center">{{load.length}} ft</td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr>
                                                                        <td align="center">{{load.distance}} <span v-if="load.distance != 'Not provided'">Miles</span></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="center">{{load.weight}} lbs</td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr>
                                                                        <td align="center">{{load.num_stops}}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="center">{{load.quantity}}</td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtable">
                                                                    <tr rowspan="2">
                                                                        <td align="center"> <a class="link-text" target="_blank"  :href="'tel:' + load.contact_phone" >{{load.contact_phone | phone}}
                                                                        </a></td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtatruck.dest_cityble action">
                                                                    <tr rowspan="2">
                                                                        <td align="center" class="non-border">
                                                                            <v-btn depressed outline icon fab dark color="orange" small>
                                                                                <v-icon color="orange">fa-eye</v-icon>
                                                                            </v-btn>
                                                                            <template v-if="(load.is_parent == 0 && load.is_recurring == 0) || (load.is_parent == 1 && load.is_recurring == 1)">
                                                                                <v-btn v-if="permissionName=='all'" :to="{name:'EditLoad', params:{id:load.uuid}}" depressed outline icon fab dark color="orange" small>
                                                                                    <v-icon>fa-edit</v-icon>
                                                                                </v-btn>
                                                                            </template>
                                                                            <v-btn class="custom_table_trash" v-if="permissionName=='all'" depressed outline icon fab dark color="red" small v-on:click.stop="DeleteLoadClick(load, 'loadRecurring')">
                                                                                <v-icon>fa-trash</v-icon>
                                                                            </v-btn>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="loadsRecurMeta.selectedRow.uuid && loadsRecurMeta.selectedRow.uuid===load.uuid" v-bind:key="`${index+'detail'}`">
                                                            <!--<td colspan="9" align="center" v-html="getRowDetail(load, renderMap, 'loadRecurring')">-->
                                                            <td colspan="9" align="center">
                                                                <LoadInfo fromComponent="loadList" :DeleteLoadClick="DeleteLoadClick" :clientUserAgent="clientUserAgent" :loadViewByClick="loadViewByClick" :permissionName="permissionName" :load="loadsRecurMeta.selectedRow" :aggregatorsKeyVal="aggregatorsKeyVal" :renderMap="renderMap" type="loadRecurring"> </LoadInfo>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td colspan="9" align="center" valign="middle" class="noRecord">{{noRecordFoundStr}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <v-toolbar color="grey darken-1" dark>
                                            <v-flex xs12 md3>
                                                PAGE {{loadsRecurMeta.pagination.currPage}} of {{loadsRecurMeta.pagination.maxPages}} ({{loadsRecurMeta.totalRecords}} {{loadsRecurMeta.totalRecords > 1 ? 'LOADS': 'LOADS'}})
                                            </v-flex>
                                            <v-flex xs12 md6 class="text-xs-center">
                                                <v-pagination v-if="loadsRecurMeta.loads.length" v-model="loadsRecurMeta.pagination.currPage" @input="onPageChange" :length="loadsRecurMeta.pagination.maxPages" :total-visible="7"></v-pagination>
                                            </v-flex>
                                            <v-flex xs12 md3 class="text-xs-right">
                                                <v-layout align-center justify-end row fill-height class="text-xs-right">
                                                    <v-flex xs8 class="text-xs-right"> SHOW</v-flex>
                                                    <v-flex xs4 class="text-xs-right">
                                                        <v-select v-model="loadsRecurMeta.pagination.perPage" @input="setPerPage" :items="[{'text': '10', value: 10}, {'text': '25', 'value':25}, {'text': '50', 'value':50},{'text': '100', 'value':100}]"></v-select>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-toolbar>
                                    </v-card>
                                </v-tab-item>
                                <!-- Recurring Loads list End -->
                            </v-tabs>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </template>
        <template v-else>
            <v-container grid-list-xl fluid paddingZero>
                <v-layout row wrap>
                    <v-flex lg12>
                        <v-card>
                            <v-toolbar card color="white">
                                <v-toolbar-title>
                                    <h3>My Loads</h3>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <router-link class="link-btn" v-if="permissionName=='all'" :to="{name: 'AddLoad'}">
                                    <v-icon color="black">add</v-icon>
                                </router-link>
                            </v-toolbar>
                            <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                            <v-divider></v-divider>
                            <v-tabs v-model="selectedTab" slider-color="orange" @change="onTabChange">
                                <v-flex xs12>
                                    <v-tab ripple> My Loads </v-tab>
                                    <v-tab ripple style="display:none;" ></v-tab>
                                    <v-tab ripple > Recurring Loads </v-tab>
                                </v-flex>
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <v-text-field solo @input="onSearchChange" label="Search" append-outer-icon="search" v-model="loadsMeta.search" class="customTxt">
                                            </v-text-field>
                                        </v-card-text>
                                        <div class="v-table__overflow">
                                            <table class="custom_table mobileview" cellpadding="0" width="100%">
                                                <tbody v-if="loadsMeta.loads.length">
                                                    <template v-for="(load, index) in loadsMeta.pageLoads">
                                                        <tr v-bind:key="index" class="custom_table_tr" v-on:click="loadsMeta.selectedRow=loadsMeta.selectedRow && loadsMeta.selectedRow.uuid===load.uuid ? {} : load">
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtableNO ">
                                                                    <tr>
                                                                        <td width="45%" class="bold td-pos-rel" valign="top">
                                                                        <template v-if="load.frequency !=''"><v-icon class="icon-pos-abs" color="green">fas fa-sync-alt</v-icon><br></template>
                                                                            <h1>
                                                                            {{utils.displayCityStateAny(load.origin_city, load.origin_state,load.origin_short_name)}} </h1>{{load.pickup_date | moment("dddd, MMMM. Do")}}<br/>
                                                                            {{load.age_display}}
                                                                        </td>
                                                                        <td width="10%" align="center" valign="top">
                                                                            <h1>
                                                                                <v-icon color="orange">arrow_forward</v-icon>
                                                                            </h1>
                                                                        </td>
                                                                        <td width="45%" class="bold" valign="top">
                                                                            <h1>{{utils.displayCityStateAny(load.dest_city, load.dest_state,load.dest_short_name)}}
                                                                            </h1>
                                                                            {{load.load_size}}
                                                                            <br/>
                                                                            {{load.company_name}}
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="loadsMeta.selectedRow.uuid && loadsMeta.selectedRow.uuid===load.uuid" v-bind:key="`${index+'detail'}`">
                                                            <!--<td align="center" v-html="getRowDetail(load, renderMap, 'load')">-->
                                                            <td align="center">
                                                                <LoadInfo fromComponent="loadList" :DeleteLoadClick="DeleteLoadClick" :clientUserAgent="clientUserAgent" :loadViewByClick="loadViewByClick" :permissionName="permissionName" :load="loadsMeta.selectedRow" :aggregatorsKeyVal="aggregatorsKeyVal" :renderMap="renderMap" type="load"> </LoadInfo>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td align="center" valign="middle" class="noRecord">{{noRecordFoundStr}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="v-table__overflow text-xs-center">
                                            <v-btn type="button" @click="onLoadMore" color="orange darken- white--text">Load More</v-btn>
                                        </div>
                                    </v-card>
                                </v-tab-item>

                                <v-tab-item ></v-tab-item>

                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <v-text-field solo @input="onSearchChange" label="Search" append-outer-icon="search" v-model="loadsRecurMeta.search" class="customTxt">
                                            </v-text-field>
                                        </v-card-text>
                                        <div class="v-table__overflow">
                                            <table class="custom_table mobileview" cellpadding="0" width="100%">
                                                <tbody v-if="loadsRecurMeta.loads.length">
                                                    <template v-for="(load, index) in loadsRecurMeta.pageLoads">
                                                        <tr v-bind:key="index" class="custom_table_tr" v-on:click="loadsRecurMeta.selectedRow=loadsRecurMeta.selectedRow && loadsRecurMeta.selectedRow.uuid===load.uuid ? {} : load">
                                                            <td>
                                                                <table width="100%" border="0" cellpadding="0" class="subtableNO ">
                                                                    <tr>
                                                                        <td width="45%" class="bold td-pos-rel" valign="top">
                                                                            <h1>
                                                                            {{utils.displayCityStateAny(load.origin_city, load.origin_state,load.origin_short_name)}} </h1>{{load.pickup_date | moment("dddd, MMMM. Do")}}<br/>
                                                                            {{load.age_display}}
                                                                        </td>
                                                                        <td width="10%" align="center" valign="top">
                                                                            <h1>
                                                                                <v-icon color="orange">arrow_forward</v-icon>
                                                                            </h1>
                                                                        </td>
                                                                        <td width="45%" class="bold" valign="top">
                                                                            <h1>{{utils.displayCityStateAny(load.dest_city, load.dest_state,load.dest_short_name)}}
                                                                            </h1>
                                                                            {{load.load_size}}
                                                                            <br/>
                                                                            {{load.company_name}}
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="loadsRecurMeta.selectedRow.uuid && loadsRecurMeta.selectedRow.uuid===load.uuid" v-bind:key="`${index+'detail'}`">
                                                            <!--<td align="center" v-html="getRowDetail(load, renderMap, 'loadRecurring')">-->
                                                            <td align="center">
                                                                <LoadInfo fromComponent="loadList" :DeleteLoadClick="DeleteLoadClick" :clientUserAgent="clientUserAgent" :loadViewByClick="loadViewByClick" :permissionName="permissionName" :load="loadsRecurMeta.selectedRow" :aggregatorsKeyVal="aggregatorsKeyVal" :renderMap="renderMap" type="loadRecurring"> </LoadInfo>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td align="center" valign="middle" class="noRecord">{{noRecordFoundStr}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="v-table__overflow text-xs-center">
                                            <v-btn type="button" @click="onLoadMore" color="orange darken- white--text">Load More</v-btn>
                                        </div>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </template>
        <template>
            <v-dialog v-model="loadViewByDialog" persistent max-width="550px">
                <v-icon style="font-size: 16px; line-height: 2; position: absolute; top: 6px;" slot="activator">load viewed by</v-icon>
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title>LOAD VIEWED BY</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="loadViewByDialog=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="pa-0 tblScrollDiv">                      
                            <table cellpadding="20" border="0" width="100%" class="dilogLoadView">
                                <template v-for="(item, index) in loadViewByInfo">
                                    <tr>
                                        <td valign="middle" width="50px">
                                                <a :href="'/user-profile?user_id='+item['user_uuid']" target="_blank" class="userPicnew" >
                                                    <img style="width:40px; height:40px;" :src="item.user_image != '' ? item.user_image : defaultProfilePicPath" />
                                                </a>
                                        </td>
                                        <td valign="middle">
                                            <a :href="'/user-profile?user_id='+item['user_uuid']" target="_blank" >
                                                {{item.user_name}}
                                            </a>
                                        </td>
                                        <td width="120px" valign="middle" class="" style="position:relative;">
                                            <v-tooltip top>
                                                <v-icon slot="activator" @click="EmailSnackbarClick(item);" color="orange">fa-envelope</v-icon>
                                                <span>View Email</span>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <v-icon slot="activator" @click="PhSnackbarClick(item);" color="orange">fa-phone-square</v-icon>
                                                <span>View Phone Number</span>
                                            </v-tooltip>
                                        </td>
                                        <td width="50px" valign="middle">{{ item.seen_count }}</td>
                                    </tr>
                                    <tr v-if="openPhSnackbarId == item.user_uuid">
                                        <td colspan="3" class="viewTxt">
                                            <input type="hidden" :id="'copy_ph_'+index" :value="item.phone_number" >
                                            {{item.phone_number}}
                                        </td>
                                        <td class="viewTxt"> 
                                            <v-tooltip top>
                                                <v-btn slot="activator" @click="copyToClipboard('copy_ph_'+index, 'Phone No.')" class="remove-border" depressed outline icon fab dark color="orange" small>
                                                    <v-icon size="30" class="main_ic" color="orange">assignment</v-icon>
                                                </v-btn>                                                
                                                <span>Copy to clipboard</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                    <tr v-if="openEmailSnackbarId == item.user_uuid">
                                        <td colspan="3" class="viewTxt">
                                            <input type="hidden" :id="'copy_email_'+index" :value="item.user_email" >
                                            {{item.user_email}}
                                        </td>
                                        <td class="viewTxt"> 
                                            <v-tooltip top>
                                                <v-btn slot="activator" @click="copyToClipboard('copy_email_'+index, 'Email')" class="remove-border" depressed outline icon fab dark color="orange" small>
                                                    <v-icon size="30" class="main_ic" color="orange">assignment</v-icon>
                                                </v-btn>
                                                <span>Copy to clipboard</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </template>
                            </table>          
                    </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template>
            <!-- Confirmation dialog for deleting role start-->
            <v-dialog v-model="showDeleteModal" persistent max-width="290">
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title>Delete {{(deleteType=='load' || deleteType =='loadRecurring') ? 'Load' : 'Template'}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="showDeleteModal=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        Are you sure you want to delete this {{deleteType}}?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="dark" small @click="showDeleteModal=false">
                            No
                        </v-btn>
                        <v-btn color="orange " class="white-text" small @click="deleteLoad">
                            Yes
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>
<script>
import API from "@/api";
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
import Material from "vuetify/es5/util/colors";
import utils from '../../util/';
import config from "../../config";
import commonServices from "../../services/CommonService";
import GoogleAds from "@/pages/widgets/GoogleAds";
import moment from 'moment';
import LoadInfo from './LoadInfo';
export default {
    components: {
        breadcrumbs,
        GoogleAds,
        LoadInfo
    },
    created() {
        const self = this;
        this.utils = utils;
        self.clientUserAgent = utils.getUserAgent();
        services
            .get("aggregators/list", {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                if (res.status === 200) {
                    self.aggregators = res.data.data;
                    res.data.data.map(function(data){
                        self.aggregatorsKeyVal[data.name] = {};
                        data.AggregatorCode.map(function(data1){
                            self.aggregatorsKeyVal[data.name][data1.mapped_code] = data1.mapped_name;    
                        })
                    });
                }                    
            })
            .catch(err => {
                console.log(err.message)
            });
    },
    mounted() {
        const self = this;
        // self.clientUserAgent = utils.getUserAgent();
        self.loadsMeta.pagination.tmpPerPage = self.loadsMeta.pagination.perPage;
        self.permissionName = this.$store.state.user ? self.$store.state.user.permissions.loads : null;
        if ((typeof this.$route.params.selectedTab != 'undefined') && (this.$route.params.selectedTab == 'addtemplate' || this.$route.params.selectedTab == 'updatetemplate')) {
            self.selectedTab = 1;
            self.onTabChange(1);
        } else {
            self.selectedTab = 0;
            self.onTabChange(0);
        }
    },
    methods: {
        DeleteLoadClick(load, type){
            this.showDeleteModal=true; 
            this.deleteId=load.uuid;
            this.deleteIndex=load.ind;
            this.deleteType=type;
        },
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        onSearchChange() {
            const self = this;            
            let keyword = self.loadsMeta.search,
                data = self.loadsMeta.tmpLoads,
                type = 'loads';
            if (self.currentTab === 1) {
                keyword = self.templMeta.search;
                data = self.templMeta.tmpTemplates;
                type = 'templates';
            } else if (self.currentTab === 2) {
                keyword = self.loadsRecurMeta.search;
                data = self.loadsRecurMeta.tmpLoads;
                type = 'loadRecurring';
            }
            clearTimeout(self.searchTimeout);
            self.searchTimeout = setTimeout(function () {
                self.filterBySearch(keyword, data);
            }, config.setTimeOutForLoadAndTruckEquipmentType);

        },
        filterBySearch(keyword, data) {
            const self = this;
            let filteredData = data;
            if (keyword.length) {
                filteredData = data.filter(dt => {
                    let filteredObj;
                    for (var key in dt) {
                        if (dt.hasOwnProperty(key) && self.allowedSearchFields[key] && typeof dt[key] === 'string') {
                            const val = dt[key];
                            if (new RegExp(keyword.trim(), "i").test(val)) {
                                filteredObj = dt;
                                break;
                            }
                        }
                    }
                    if (filteredObj) {
                        return filteredObj;
                    }
                });
            }
            // self.currentTab === 0 ? (self.loadsMeta.loads = self.loadsMeta.pageLoads = filteredData) : self.templMeta.templates = filteredData;
            if(self.currentTab === 0) {
                self.loadsMeta.loads = self.loadsMeta.pageLoads = filteredData;
            } else if(self.currentTab === 2) {
                self.loadsRecurMeta.loads = self.loadsRecurMeta.pageLoads = filteredData;
            } else {
                self.templMeta.templates = filteredData;
            }
            self.countMaxPages();
            self.onPageChange(1)
        },
        async getLoads(limit=config.setPerPageRecord, offset=0,type, appendLoads=0) {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            self.loadsMeta.search = '';
            await commonServices.getEquipmentTypes(this.$store.state.user.token,"list").then(res => {
                self.equipment_types = JSON.parse(JSON.stringify(res.equipment_types));
                self.equipment_type_codes = JSON.parse(JSON.stringify(res.equipment_type_codes));
                services.get("loads/list", {Authorization: "Bearer " + this.$store.state.user.token}, {show_all: false,limit:limit,offset:offset,order_by:this['loadsMeta'].currentSorting, order_type:this['loadsMeta'].sortType}).then(res => {
                    if (res.status === 200) {
                        self.loadsMeta.totalRecords = res.data.totalRecords;
                        self.loadsMeta.loads = res.data.data.map((dt, i) => {
                            dt.origin = dt.origin_city + ', ' + dt.origin_state;
                            dt.dest = dt.dest_city + ', ' + dt.dest_state;
                            dt.age = utils.dateDiff(self.currDate, dt.updated_date, 's');
                            dt.distance = utils.getDistanceDisplay(dt.distance);
                            dt.ind = i;
                            dt.age_display = utils.getDateDiffDisplay(dt.updated_date);
                            if(dt.notes !== ''){
                                dt.equipment_type_ids = dt.equipment_type_ids+','+config.SeeNotes
                            }
                            utils.getEquipmentListDisplay(dt.equipment_type_ids,self.equipment_type_codes,self.equipment_types,config.shortFormStr,function(result){
                                dt.equipment_name = result;
                            });
                            return dt;
                        });
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        if(self.clientUserAgent){
                            if(appendLoads == 1){
                                self[type].pageLoads = self.loadsMeta.loads = self[type].pageLoads.concat(self.loadsMeta.loads.slice(0));
                                self[type].tmpLoads = self[type].tmpLoads.concat(self.loadsMeta.loads.slice());
                            } else {
                                self[type].pageLoads = self.loadsMeta.loads;
                                self[type].tmpLoads = self.loadsMeta.loads.slice();
                            }                            
                        } else {
                            self[type].pageLoads = self.loadsMeta.loads;
                            self[type].tmpLoads = self.loadsMeta.loads.slice();
                        }
                        self.countMaxPages();
                        setTimeout(function(){utils.tableReArrangement();},100)
                    }
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, config.errMsgColorStr);
                });
            })
            .catch(err =>{
                this._showToast(err.message, config.errMsgColorStr);
            });
        },        
        onLoadMore() {
            let type = 'loadsMeta';
            let page = this[type].pagination.currPage = this[type].pagination.currPage+1;
            // const perPg = this.pagination.perPage;
            // const offset = page <= 1 ? 0 : ((page - 1) * perPg);
            this[type].pagination.currPage = page;
            const perPg = this[type].pagination.perPage;
            this.countMaxPages();
            const offset = page <= 1 ? 0 : ((page - 1) * perPg);
            const limit = offset + perPg;

            this.getLoads(perPg,offset,type, 1);
        },        
        async getTemplates() {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            await commonServices.getEquipmentTypes(this.$store.state.user.token,"list").then(res => {
                self.equipment_types = JSON.parse(JSON.stringify(res.equipment_types));
                self.equipment_type_codes = JSON.parse(JSON.stringify(res.equipment_type_codes));
                services.get("loads/templates/list", {Authorization: "Bearer " + this.$store.state.user.token}).then(res => {
                    if (res.status === 200) {
                        self.templMeta.templates = res.data.data.map((dt, i) => {
                            dt.origin = dt.origin_city + ', ' + dt.origin_state;
                            dt.dest = dt.dest_city + ', ' + dt.dest_state;
                            dt.distance = utils.getDistanceDisplay(dt.distance);
                            dt.ind = i;
                            if(dt.notes !== ''){
                                dt.equipment_type_ids = dt.equipment_type_ids+','+config.SeeNotes
                            }
                            utils.getEquipmentListDisplay(dt.equipment_type_id,self.equipment_type_codes,self.equipment_types,config.shortFormStr,function(result){
                                dt.equipment_name = result;
                            });
                            return dt;
                        });
                        self.templMeta.tmpTemplates = self.templMeta.templates.slice();
                        self.onPageChange(self.templMeta.pagination.currPage);
                        wApp.$emit("showLoader", {
                            show: false
                        });
                    }
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, config.errMsgColorStr);
                });
            })
            .catch(err =>{
                this._showToast(err.message, config.errMsgColorStr);
            });
        },
        deleteLoad() {
            const self = this,
                wApp = window.getApp;
            const deleteUrl = (self.deleteType == 'load' || self.deleteType == 'loadRecurring')  ? 'loads/delete' : 'loads/templates/delete';
            wApp.$emit("showLoader", {
                show: true
            });
            self.showDeleteModal = false
            services
                .delete(deleteUrl, {
                    uuid: self.deleteId
                }, {
                    Authorization: "Bearer " + this.$store.state.user.token
                })
                .then(res => {
                    if (res.status === 200) {
                        self._showToast(res.data.message, res.data.is_error ? config.errMsgColorStr : config.successMsgColorStr);
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        if (self.deleteType == 'load') {
                            self.onPageChange(1);
                        } else if (self.deleteType == 'loadRecurring') {
                            self.onPageChange(1);
                        } else {
                            self._sliceFromArr(self.templMeta.templates);
                            self._sliceFromArr(self.templMeta.tmpTemplates);
                            self.countMaxPages();
                            if (self.templMeta.pagination.maxPages < self.templMeta.pagination.currPage) {
                                self.onPageChange(self.templMeta.pagination.maxPages);
                            } else {
                                self.onPageChange(self.templMeta.pagination.currPage);
                            }
                        }
                    }
                    self.deleteId = null;
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, config.errMsgColorStr);
                    self.deleteId = null;
                });
        },
        _sliceFromArr(data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i].ind == this.deleteIndex) {
                    data.splice(i, 1);
                    break;
                }
            }
        },
        switchSort(field, valType = 'str') {
            let metaType = 'loadsMeta',
                type = 'loads';
            if (this.currentTab == 1) {
                metaType = 'templMeta';
                type = 'templates';
            }
            this[metaType].currentSorting = field;
            if (field === this[metaType].currentSorting) {
                this[metaType].sortType = this[metaType].sortType == 'asc' ? 'desc' : 'asc';
            } else {
                this[metaType].sortType = 'asc';
            }
            if (this[metaType][type].length > 1) {
                // this[metaType][type].sortBy(field, this[metaType].sortType, valType);
                this.onPageChange(1);
            }
        },
        setPerPage(page) {
            if (this.currentTab == 0) {
                if (page != this.loadsMeta.pagination.tmpPerPage) {
                    this.loadsMeta.pagination.tmpPerPage = page;
                    this.onPageChange(1);
                }
            } else {
                if (page != this.templMeta.pagination.tmpPerPage) {
                    this.templMeta.pagination.tmpPerPage = page;
                    this.onPageChange(1);
                }
            }
        },
        countMaxPages() {
            if (this.currentTab == 0) {
                this.loadsMeta.pagination.maxPages = Math.ceil(this.loadsMeta.totalRecords / this.loadsMeta.pagination.perPage);
                if (this.loadsMeta.pagination.maxPages == 0) {
                    this.loadsMeta.pagination.maxPages = 1;
                }
            } else if (this.currentTab == 2) {
                this.loadsRecurMeta.pagination.maxPages = Math.ceil(this.loadsRecurMeta.totalRecords / this.loadsRecurMeta.pagination.perPage);
                if (this.loadsRecurMeta.pagination.maxPages == 0) {
                    this.loadsRecurMeta.pagination.maxPages = 1;
                }
            } else {
                this.templMeta.pagination.maxPages = Math.ceil(this.templMeta.templates.length / this.templMeta.pagination.perPage);
                if (this.templMeta.pagination.maxPages == 0) {
                    this.templMeta.pagination.maxPages = 1;
                }
            }
        },
        onPageChange(page) {
            let type;
            if(this.currentTab == 0){
                type = 'loadsMeta'
            } else if(this.currentTab == 1){
                type = 'templMeta';
            } else if(this.currentTab == 2){
                type = 'loadsRecurMeta';
            } 
            this[type].pagination.currPage = page;
            const perPg = this[type].pagination.perPage;
            this.countMaxPages();
            const offset = page <= 1 ? 0 : ((page - 1) * perPg);
            const limit = offset + perPg;
            if (this.currentTab == 0) {
                this.getLoads(perPg, offset,type);
            } else if (this.currentTab == 1){
                this[type].pageTemplates = this[type].templates.slice(offset, limit);
            } else if (this.currentTab == 2){
                this.getRecurringLoads(perPg, offset,type);
            }
        },
        renderMap(id, load) {
            let startAdd = new google.maps.LatLng(load.origin_lat, load.origin_lng);
            let endAdd = new google.maps.LatLng(load.dest_lat, load.dest_lng);
            const directionsDisplay = new google.maps.DirectionsRenderer,
                directionsService = new google.maps.DirectionsService;
            const map = new google.maps.Map(document.getElementById(id), {
                zoom: 7,
                center: {
                    lat: 41.85,
                    lng: -87.65
                }
            });
            directionsDisplay.setMap(map);
            directionsService.route({
                origin: load.origin_lat + "," + load.origin_lng,
                destination: load.dest_lat + "," + load.dest_lng,
                travelMode: 'DRIVING'
            }, function (response, status) {
                if (status === 'OK') {
                    let startContentString = '<div id="content" class="MarkerLabelFontCls">' + response.routes[0].legs[0].start_address + '</div>';
                    let startInfowindow = new google.maps.InfoWindow({
                        content: startContentString
                    });
                    // The marker, positioned at Uluru
                    let startMarker = new google.maps.Marker({
                        position: startAdd,
                        map: map,
                        icon: '/static/icon/map-marker-a.svg',
                        zIndex: 999
                    });
                    startMarker.addListener('click', function () {
                        startInfowindow.open(map, startMarker);
                    });


                    let endContentString = '<div id="content" class="MarkerLabelFontCls">' + response.routes[0].legs[0].end_address + '</div>';
                    let endInfowindow = new google.maps.InfoWindow({
                        content: endContentString
                    });
                    // The marker, positioned at Uluru
                    var endMarker = new google.maps.Marker({
                        position: endAdd,
                        map: map,
                        icon: '/static/icon/map-marker-b.svg',
                        zIndex: 999
                    });
                    endMarker.addListener('click', function () {
                        endInfowindow.open(map, endMarker);
                    });
                    directionsDisplay.setDirections(response);
                }
            });
        },
        onRecurringLoadMore() {
            let type = 'loadsRecurMeta';
            let page = this[type].pagination.currPage = this[type].pagination.currPage+1;
            // const perPg = this.pagination.perPage;
            // const offset = page <= 1 ? 0 : ((page - 1) * perPg);
            this[type].pagination.currPage = page;
            const perPg = this[type].pagination.perPage;
            this.countMaxPages();
            const offset = page <= 1 ? 0 : ((page - 1) * perPg);
            const limit = offset + perPg;

            this.getRecurringLoads(perPg,offset,type, 1);
        },
        onTabChange(tab) {
            const self = this;
            self.currentTab = tab;
            let type;
            if(self.currentTab == 0){
                type = 'loadsMeta'
            } else if(self.currentTab == 1){
                type = 'templMeta';
            } else if(self.currentTab == 2){
                type = 'loadsRecurMeta';
            }
            // const type = self.currentTab == 0 ? 'loadsMeta' : 'templMeta';
            if (tab == 0) {
                // if (self.loadsMeta.loads.length) {
                //     return;
                // }
                self.getLoads(config.setPerPageRecord, 0,type);
            } else if (tab == 1) {
                if (self.templMeta.templates.length) {
                    return;
                }
                self.getTemplates();
            } else if (tab == 2) {
                self.getRecurringLoads(config.setPerPageRecord, 0,type);
            }
        },
        getSortArrow(field) {
            const self = this;
            let metaType;
            if(self.currentTab == 0){
                metaType = 'loadsMeta'
            } else if(self.currentTab == 1){
                metaType = 'templMeta';
            } else if(self.currentTab == 2){
                metaType = 'loadsRecurMeta';
            }
            // const metaType = this.currentTab == 0 ? 'loadsMeta' : 'templMeta';
            let arr = 'arrow_drop_up';
            if (this[metaType].currentSorting === field && this[metaType].sortType === 'desc') {
                arr = 'arrow_drop_down';
            }
            return arr;
        },
        getRowDetail(load, cb, type) {
            // const self = this,r = this[metaType].selectedRow;
            // metaType = type == 'load' ? 'loadsMeta' : 'templMeta',
            let metaType;
            if(type == 'load'){
                metaType = 'loadsMeta';
            } else if(type == 'template'){
                metaType = 'templMeta';
            } else if(type == 'loadRecurring'){
                metaType = 'loadsRecurMeta';
            }
            const self = this,r = this[metaType].selectedRow;
            if (!self.clientUserAgent) {
                setTimeout(() => {
                    cb(r.uuid + '-map', load);
                }, config.setTimeOutForLoadAndTruckDetailMap);
                let html = `<table width="100%" border="0" cellpadding="0" class="subtable viewdetail">
                    <tr>
                        <th align="center" width="30">
                            BROKER
                        </th>
                        <th align="center" width="30"> LOAD </th>
                        <th align="center" width="40" class="pos-relative">DESTINATION`;
                if (type == 'load' || type == 'loadRecurring') {
                    html += `<a class="v-btn--router v-chip v-chip--label orange white--text full-load-btn" href='/myloads/detail/` + r.uuid + `'><i class="v-icon fa fa-expand theme--light white--text"></i></a>`;
                }
                html += `</th>
                        </tr>
                        <tr>
                            <td valign="top" align="left" width="30%">
                                <div class='unset-case'>
                                    <strong>Name:</strong> ` + utils.getDataDisplay(r.contact_name) + `<br />
                                    <strong>Phone No.:</strong> `;
                                    let phone = utils.getPhoneFormatDisplay(r.contact_phone);

                                    if (phone != config.notProvidedStr) {
                                        if(Array.isArray(phone)){
                                            phone.map((phn, index)=> {
                                                html += `<a class="link-text" target="_blank" href="tel:` + phn + `">` + phn + `</a>`;
                                                if(index < phone.length-1){
                                                    html += ', ';
                                                }
                                            })
                                        } else{
                                            html += `<a class="link-text" target="_blank" href="tel:` + phone + `">` + phone + `</a>`;
                                        }                                    
                                    } else {
                                        html += phone;
                                    }
                                    // if (phone != config.notProvidedStr) {
                                    //     html += `<a class="link-text" target="_blank" href="tel:` + phone + `">` + phone + `</a>`;
                                    // } else {
                                    //     html += phone;
                                    // }
                                    html += `<br />
                                    <strong>Email:</strong> `;
                                    let email = utils.getDataDisplay(r.contact_email);
                                    if (email != config.notProvidedStr) {
                                        html += `<a class="link-text" target="_blank" href="mailto:` + email + `">` + email + `</a>`;
                                    } else {
                                        html += email;
                                    }
                                    html += `<br />
                                    <strong>Company:</strong>`;
                                    let companyName = utils.getDataDisplay((type == 'load' || type == 'loadRecurring') ? r.company_name : r.User.company_name);
                                    // if(r.source == 'posteverywhere') {
                                    //     companyName = utils.getDataDisplay(r.load_company_name);
                                    // }
                                    html += companyName + `<br />
                                    <strong>MC Number:</strong> `;
                                    let mcNumber = utils.getDataDisplay((type == 'load' || type == 'loadRecurring') ? r.mc_number : r.User.mc_number);
                                    // if(r.source == 'posteverywhere') {
                                    //     html += utils.getDataDisplay(r.load_mc_number);
                                    // } else 
                                    if (mcNumber != config.notProvidedStr) {
                                        html += `<a class="link-text" target="_blank" href="`+config.mcNumberLocation+mcNumber+`">`+mcNumber+`</a>`;
                                    } else {
                                        html += mcNumber;
                                    }
                                    html += `<br />`;
                                    if(r.source == 'postonce') {
                                        let usrName = utils.getDataDisplay(r.aggregator_account_name);
                                        html += `<strong><span style="text-transform: capitalize;">`+r.source+`</span> Member Id:</strong> <span style="text-transform: capitalize;">` + usrName + `</span> <br />`;
                                    } else {
                                        html += `<strong>LOADMAX Forum Username:</strong> ` + utils.getDataDisplay((type == 'load' || type == 'loadRecurring') ? r.discourse_user_name : r.User.discourse_user_name) + ` <br />`;
                                    }
                                    //html += `<br />`;
                                    if((type == 'load' || type == 'loadRecurring') && r.frequency != '') {
                                        html += `<strong>Recurring: </strong> ` + utils.getDataDisplay(utils.getTitleCase(r.frequency)) + `<strong> Until </strong>`+moment(r.end_date).format('YYYY-MM-DD')+` <br />`;
                                    }
                                html += `</div>
                            </td>
                            <td valign="top" align="left" width="30%">
                                <div class='unset-case'>
                                    <strong>Height:</strong> ` + r.height + ` ft<br /> 
                                    <strong>Weight:</strong> ` + r.weight + ` lbs<br />
                                    <strong>Length:</strong> ` + r.length + ` ft<br />
                                    <strong>Equipment and Accessories:</strong> ` + r.equipment_name + `<br />
                                    <strong>Notes:</strong> ` + utils.getNotesNameFromKey(r.notes, self.aggregatorsKeyVal, r.source) + `<br />
                                    <strong>Descriptions and Comments:</strong> ` + utils.getDescriptionDisplay(r.description)+ `<br />
                                    <strong>Load ID:</strong> ` + ((r.source == 'posteverywhere') ? config.notProvidedStr : utils.getDataDisplay(r.reference_number)) + `<br />
                                </div>
                            </td>
                            <td valign="top" align="left" width="40%">
                                <div style="height:200px;" id="` + r.uuid + `-map"></div>
                            </td>
                        </tr>
                    </table>`;
                return html;
            }else{
                let html = `<div class="mobilefullLoad"><div class='unset-case'>
                <h1>BROKER</h1>
                <strong>Name:</strong> ` + utils.getDataDisplay(r.contact_name) + `<br />
                <strong>Phone:</strong> `;
                let phone = utils.getPhoneFormatDisplay(r.contact_phone);
                if (phone != config.notProvidedStr) {
                    if(Array.isArray(phone)){
                        phone.map((phn, index)=> {
                            html += `<a class="link-text" target="_blank" href="tel:` + phn + `">` + phn + `</a>`;
                            if(index < phone.length-1){
                                html += ', ';
                            }
                        })
                    } else{
                        html += `<a class="link-text" target="_blank" href="tel:` + phone + `">` + phone + `</a>`;
                    }                                    
                } else {
                    html += phone;
                }
                // if (phone != config.notProvidedStr) {
                //     html += `<a class="link-text" target="_blank" href="tel:` + phone + `">` + phone + `</a>`;
                // } else {
                //     html += phone;
                // }
                html += `<br />
                <strong>Company:</strong>`;
                let companyName = utils.getDataDisplay((type == 'load' || type == 'loadRecurring') ? r.company_name : r.User.company_name);
                // if(r.source == 'posteverywhere') {
                //     companyName = utils.getDataDisplay(r.load_company_name);
                // }
                html += companyName + `<br />
                <strong>Email:</strong> `;
                let email = utils.getDataDisplay(r.contact_email);
                if (email != config.notProvidedStr) {
                    html += `<a class="link-text" target="_blank" href="mailto:` + email + `">` + email + `</a>`;
                } else {
                    html += email;
                }
                html += `<br />
                <strong>MC Number:</strong> `;
                let mcNumber = utils.getDataDisplay((type == 'load' || type == 'loadRecurring') ? r.mc_number : r.User.mc_number);
                // if(r.source == 'posteverywhere') {
                //     html += utils.getDataDisplay(r.load_mc_number);
                // } else 
                if (mcNumber != config.notProvidedStr) {
                    html += `<a class="link-text" target="_blank" href="`+config.mcNumberLocation+mcNumber+`">`+mcNumber+`</a>`;
                } else {
                    html += mcNumber;
                }
                html += `<br />`;
                if(r.source == 'postonce') {
                    let usrName = utils.getDataDisplay(r.aggregator_account_name);
                    html += `<strong><span style="text-transform: capitalize;">`+r.source+`</span> Member Id:</strong> <span style="text-transform: capitalize;">` + usrName + ` </span><br />`;
                } else {
                    html += `<strong>LOADMAX Forum Username:</strong> ` + utils.getDataDisplay((type == 'load' || type == 'loadRecurring') ? r.discourse_user_name : r.User.discourse_user_name) + ` <br />`;
                } 
                if((type == 'load' || type == 'loadRecurring') && r.frequency != '') {
                    html += `<strong>Recurring: </strong> ` + utils.getDataDisplay(utils.getTitleCase(r.frequency)) + `<strong> Until </strong>`+moment(r.end_date).format('YYYY-MM-DD')+` <br />`;
                }
                html += `</div>
                <div class='unset-case'>
                    <h1>LOAD</h1>
                        <strong>Height:</strong> ` + r.height + ` ft<br />
                        <strong>Weight:</strong> ` + r.weight + ` lbs<br />
                        <strong>Length:</strong> ` + r.length + ` ft<br />
                        <strong>Equipment and Accessories:</strong> ` + r.equipment_name + `<br />
                        <strong>Notes:</strong> ` + utils.getNotesNameFromKey(r.notes, self.aggregatorsKeyVal, r.source) + `<br />
                        <strong>Descriptions and Comments:</strong> ` + utils.getDescriptionDisplay(r.description)+`<br />
                        <strong>Load ID:</strong> ` + ((r.source == 'posteverywhere') ? config.notProvidedStr : utils.getDataDisplay(r.reference_number)) + `<br />
                </div>
                <a class="v-btn--router orange white--text btnfull " href='/myloads/detail/` + r.uuid + `'><i class="v-icon fa fa-expand theme--light white--text"></i></a>
                </div>`;
                return html;
            }
        },
        async getRecurringLoads(limit=config.setPerPageRecord, offset=0,type, appendLoads=0) {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            self.loadsRecurMeta.search = '';
            await commonServices.getEquipmentTypes(this.$store.state.user.token,"list").then(res => {
                self.equipment_types = JSON.parse(JSON.stringify(res.equipment_types));
                self.equipment_type_codes = JSON.parse(JSON.stringify(res.equipment_type_codes));
                services.get("loads/recurring-loads", 
                {Authorization: "Bearer " + this.$store.state.user.token},
                 {show_all: false,limit:limit,offset:offset,order_by:this['loadsRecurMeta'].currentSorting, order_type:this['loadsRecurMeta'].sortType})
                 .then(res => {
                    if (res.status === 200) {
                        self.loadsRecurMeta.totalRecords = res.data.totalRecords;
                        self.loadsRecurMeta.loads = res.data.data.map((dt, i) => {
                            dt.origin = dt.origin_city + ', ' + dt.origin_state;
                            dt.dest = dt.dest_city + ', ' + dt.dest_state;
                            dt.age = utils.dateDiff(self.currDate, dt.updated_date, 's');
                            dt.distance = utils.getDistanceDisplay(dt.distance);
                            dt.ind = i;
                            dt.age_display = utils.getDateDiffDisplay(dt.updated_date);
                            if(dt.notes !== ''){
                                dt.equipment_type_ids = dt.equipment_type_ids+','+config.SeeNotes
                            }
                            utils.getEquipmentListDisplay(dt.equipment_type_ids,self.equipment_type_codes,self.equipment_types,config.shortFormStr,function(result){
                                dt.equipment_name = result;
                            });
                            return dt;
                        });
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        if(self.clientUserAgent){
                            if(appendLoads == 1){
                                self[type].pageLoads = self.loadsRecurMeta.loads = self[type].pageLoads.concat(self.loadsRecurMeta.loads.slice(0));
                                self[type].tmpLoads = self[type].tmpLoads.concat(self.loadsRecurMeta.loads.slice());
                            } else {
                                self[type].pageLoads = self.loadsRecurMeta.loads;
                                self[type].tmpLoads = self.loadsRecurMeta.loads.slice();
                            }                            
                        } else {
                            self[type].pageLoads = self.loadsRecurMeta.loads;
                            self[type].tmpLoads = self.loadsRecurMeta.loads.slice();
                        }                    
                        self.countMaxPages();
                        setTimeout(function(){utils.tableReArrangement();},100)
                    }
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, config.errMsgColorStr);
                });
            })
            .catch(err =>{
                this._showToast(err.message, config.errMsgColorStr);
            });
        },
        loadViewByClick(data){
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            self.loadViewByDialog = false;
            services
            .get("loads/seen-details?load_uuid="+data.uuid, {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.status === 200) {
                    self.loadViewByDialog = true;
                    self.loadViewByInfo = res.data.data;
                }                    
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                console.log(err.message)
            });
        },
        snackbar_ph_div(data){
            let html = `<div class='snackbar_ph'>`+data.user_name;
            // html += "<v-btn depressed outline icon fab dark color='orange' small><v-icon color='orange'>fa-envelope</v-icon></v-btn>";
            html += `<i @click="" class="v-icon fa fa-close theme--dark orange--text"></i>`;
            return html;
        },
        PhSnackbarClick(item){
            const self = this;
            self.openPhSnackbarId = false;
            self.openEmailSnackbarId = false;
            self.openPhSnackbarId = item.user_uuid;
        },
        EmailSnackbarClick(item){
            const self = this;
            self.openEmailSnackbarId = false;
            self.openPhSnackbarId = false;
            self.openEmailSnackbarId = item.user_uuid;
        },
        copyToClipboard (id, text){
            const self = this;
            let aa = document.querySelector('#'+id)
            aa.setAttribute('type', 'text')
            aa.select();
            document.execCommand("copy");
            aa.setAttribute('type', 'hidden')
            self._showToast(text +' copied');
        },
    },
    data: () => ({
        defaultProfilePicPath:config.defaultProfilePicPath,
        openPhSnackbarId: false,
        openEmailSnackbarId: false,
        loadViewByDialog: false,
        loadViewByInfo: [],
        aggregatorsKeyVal: {},
        currDate: new Date(),
        clientUserAgent: config.clientUserAgent,
        noRecordFoundStr:config.noRecordFoundStr,
        anywhereStr:config.anywhereStr,
        blankStr:config.blankStr,
        shortFormStr:config.shortFormStr,
        utils: null,
        selectedTab: 0,
        color: Material,
        permissionName: null,
        deleteType: 'load',
        deleteId: null,
        deleteIndex: null,
        searchTimout: 0,
        allowedSearchFields: {
            origin: true,
            dest: true,
            pickup_date: true,
            rate: true,
            equipment_name: true,
            load_size: true,
            length: true,
            distance: true,
            weight: true,
            contact_phone: true,
            template_name: true,
            age_display:true
        },
        loadsMeta: {
            search: '',
            loads: [],
            tmpLoads: [],
            pageLoads: [],
            selectedRow: {},
            currentSorting: null,
            sortType: null,
            totalRecords:0,
            pagination: {
                currPage: 1,
                perPage: config.setPerPageRecord,
                tmpPerPage: 0,
                maxPages: 0
            },
        },
        loadsRecurMeta: {
            search: '',
            loads: [],
            tmpLoads: [],
            pageLoads: [],
            selectedRow: {},
            currentSorting: null,
            sortType: null,
            totalRecords:0,
            pagination: {
                currPage: 1,
                perPage: config.setPerPageRecord,
                tmpPerPage: 0,
                maxPages: 0
            },
        },
        templMeta: {
            search: '',
            templates: [],
            tmpTemplates: [],
            pageTemplates: [],
            selectedRow: {},
            currentSorting: null,
            sortType: 'asc',
            totalRecords:0,
            pagination: {
                currPage: 1,
                perPage: config.setPerPageRecord,
                tmpPerPage: 0,
                maxPages: 0
            },
        },
        showDeleteModal: false,
        currentTab: 0,
        equipment_types: [],
        equipment_type_codes:[],
        breadcrumbs: [{
                name: 'Dashboard',
                to: "/dashboard",
                disabled: false
            },
            {
                name: 'Broker/Shipper',
                disabled: true
            },
            {
                name: 'My Loads',
                to: "/loads/list",
                disabled: false
            }
        ]
    })
};

Array.prototype.sortBy = function (p, type, valType) {
    return this.sort(function (a, b) {
        if (a[p] && b[p]) {
            var val1, val2;
            if (valType === 'num') {
                val1 = parseFloat(a[p]);
                val2 = parseFloat(b[p]);
                return type == 'asc' ? val1 - val2 : val2 - val1;
            } else {
                val1 = a[p].toString().toLowerCase();
                val2 = b[p].toString().toLowerCase();

                if (type == 'asc') {
                    return (val1 > val2) ? 1 : (val1 < val2) ? -1 : 0;
                } else {
                    return (val2 > val1) ? 1 : (val2 < val1) ? -1 : 0;
                }
            }
        }
    });
}
</script>
<style lang="stylus">
.v-datatable.v-table {
    .v-chip.v-chip--label {
        margin: 4px 4px 4px 16px
    }
}
.v-btn.remove-border {
    border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/loads/List.vue